import React, { createRef, useCallback } from "react";
import GridItem from "../../components/Grid/GridItem";
import QRCode from "react-qr-code";
import GridContainer from "../../components/Grid/GridContainer";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle";
import getSymbolFromCurrency from 'currency-symbol-map'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as PayshapLogo } from "../../assets/img/payshap_logo.svg";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../components/CustomButtons/Button.js";
import { whiteColor } from "../../assets/jss/eclipse";
import * as htmlToImage from 'html-to-image';
import { generatePDF } from "../../utils/generatePDF";
import { primaryTextColor } from "../../style.scss"
import { connect } from "react-redux";
import crc from 'crc';

const useStyles = makeStyles(themeStyle);

const DisplayPayshapQR = (props) => {
  const pageState = useLocation().state;
  const mobileNumber = pageState?.mobileNumber;
  const bank = pageState?.bankCode?.replaceAll(' ','').toLowerCase();
  const amount = Math.trunc(pageState?.amount);
  const qrReference = pageState?.reference;
  const emvLink = `00020101021230360013za.co.payshap${mobileNumber}@${bank}62270508${qrReference}0611PieterRoux5204482953037105406${amount}5802ZA5911PayshapP2P6012Johannesburg`;
  const crcCode = `6304` + crc.crc16(`${emvLink}`).toString(16);
  const eVMQRCode = emvLink + crcCode;
  const classes = useStyles();
  const history = useHistory();
  const qrCodeRef = createRef();
  const appLink = props?.appData?.template?.appLink;

  const download = useCallback(async() => {
    const dataUrl = await htmlToImage.toPng(qrCodeRef?.current);
    if(dataUrl) generatePDF(dataUrl, appLink);
  },[qrCodeRef, appLink])

  const handleBack = useCallback(() => {
    history.push({
      pathname: '/pages/qr-payshap-generate',
      state:{...pageState}
    });
  }, [history, pageState]);

  const backToQRGenerate = useCallback(() => {
    history.push({
      pathname: '/pages/qr-payshap-generate'
    });
  }, [history]);

  React.useEffect(() => {
    return () => {
      window.onpopstate = () => {
        handleBack();
      }
    };
  }, [handleBack])

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ display: 'flex' }}>
              <ArrowBackIosIcon className={classes.linkColor} onClick={handleBack} />
              <span className={classes.title}>Scan PayShap QR code</span>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem  xs={12} sm={12} md={12}>
        <div style={{padding:"14px 0px 20px 0px"}}><p className={classes.title + ' ' + classes.textCenter + ' m-b-0 m-t-0'} ><b>Show or download and share the PayShap QR code with your payor to scan and pay.</b></p></div>
        <div ref={qrCodeRef} style={{background: `linear-gradient(163.24deg, #007AFF 31.54%, #050C43 88.12%)`, paddingBottom:"16px", borderRadius:"12px"}}>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <p className={classes.title + ' ' + classes.textCenter + ' m-b-0 m-t-0'}  style={{color:whiteColor}}><b>You are about to pay <br></br>{qrReference}</b></p>
                {amount > 0 ?
                  <h2 style={{ margin: '0', color:whiteColor }} className={classes.textCenter}><b>{getSymbolFromCurrency("ZAR")}{(+amount).toFixed(2)}</b></h2>
                  : null
                }
              </GridItem>
              <div style={{display:"flex", justifyContent:"center", width:"100%"}}>
              <div style={{padding:"8px", background:whiteColor, borderRadius:"12px" }}>
              <GridItem xs={12} sm={12} md={12}>
                <p className={classes.textCenter + ' m-b-0 m-t-0'}>
                  <QRCode value={eVMQRCode} size={164} />
                </p>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0 m-t-0'}>
                  <b>{`ShapID:`} {mobileNumber + `@`}<br></br>{bank}</b>
                  </p>
              </GridItem>
              </div>
              </div>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-1 m-t-0'}  style={{color:whiteColor}}><b>Pay with</b> &nbsp;<PayshapLogo /></p>
          </GridItem>
        </div>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem style={{marginTop:"24px"}}>
          <p className={classes.title + ' ' + classes.textCenter + ' m-b-0 m-t-0'} ><b>How to pay a PayShap QR code</b></p>
            <p className={classes.title + ' ' + classes.textCenter + ' m-b-0 m-t-1'} >
            <a target="_blank" rel="noopener noreferrer" href={`${appLink}`} style={{color: primaryTextColor}}><b>Click here</b></a> to register to scan and pay
              <br></br>Or <br></br>
              Register for PayShap on your bank's app or online banking and pay
            </p>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Button className={classes.buttonRadius} size="lg" block color="primary" type="submit" onClick={download}>Download QR code</Button>
        </GridItem>
        <GridItem xs={12} sm={12} md={12} style={{marginBottom:"16px"}}>
          <Button className={classes.buttonRadius} size="lg" block color="transparent" type="submit" onClick={backToQRGenerate}>Generate another QR</Button>
        </GridItem>
      </GridContainer>
    </div>
  )
}

const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

export default connect(mapStateToProps)(DisplayPayshapQR);